export default "/_next/static/001e0ff69c08bc94fb2d150c1b5c24b8.png";